/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'device-lg': {
    width: 16,
    height: 16,
    viewBox: '0 2 24 20',
    data: '<path pid="0" d="M21 16H3V4h18m0-2H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h7v2H8v2h8v-2h-2v-2h7a2 2 0 002-2V4a2 2 0 00-2-2z"/>'
  }
})
